var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-title": "Abbrechen",
        "modal-class": "email-set-reminder-modal info-card editMode",
        "ok-disabled": !_vm.dateValue,
        "ok-title": "Speichern",
        size: "md",
        title: "Wiedervorlagedatum setzen",
        visible: _vm.show,
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
        ok: function ($event) {
          $event.preventDefault()
          return _vm.onConfirm.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "b-form-group",
        {
          staticClass: "info-card-element",
          attrs: {
            label: "Wiedervorlagedatum",
            "label-for": "reminder-date-input",
          },
        },
        [
          _c("csp-datepicker", {
            attrs: {
              id: "reminder-date-input",
              "min-date": _vm.tomorrowString,
            },
            model: {
              value: _vm.dateValue,
              callback: function ($$v) {
                _vm.dateValue = $$v
              },
              expression: "dateValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }